/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiJingleCollectionsIdJinglesPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

export const deleteApiJingleCollectionsIdJinglesQueryParamsSchema = z.object({
    "BindIds": z.array(z.string().uuid()).describe("Идентификаторы связок")
    })

/**
 * @description Успешно
 */
export const deleteApiJingleCollectionsIdJingles200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiJingleCollectionsIdJingles400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiJingleCollectionsIdJingles401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiJingleCollectionsIdJingles403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Not Found
 */
export const deleteApiJingleCollectionsIdJingles404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiJingleCollectionsIdJingles500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiJingleCollectionsIdJinglesMutationResponseSchema = z.lazy(() => deleteApiJingleCollectionsIdJingles200Schema)